import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MessageTemplateAutocomplete from 'components/common/MessageTemplateAutocomplete';
import MessageTemplateSelector from 'components/common/MessageTemplateSelector';
import Editor from 'components/editor/Editor';
import Loading from 'components/loading/Loading';
import { useEffect, useRef, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const TicketDescriptionEditModal = ({
  showModal,
  data,
  handleClose,
  handleSubmit,
  isLoading,
  ticketId
}) => {
  const [description, setDescription] = useState('');
  const [validated, setValidated] = useState(false);
  const form = useRef(null);
  const editorRef = useRef(null);

  useEffect(() => {
    if (data) {
      setDescription(data);
      setValidated(false);
    }
  }, [data]);

  const onSubmit = e => {
    if (form.current.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
    } else {
      handleSubmit({ description: description });
      setValidated(false);
    }
  };
  return (
    <Modal size="lg" show={showModal} onHide={handleClose}>
      {isLoading && <Loading />}
      <Modal.Header closeButton>
        <Modal.Title>Editar descrição</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form validated={validated} ref={form}>
          <Form.Group className="mb-3" controlId="editForm.Name">
            <Form.Label className="d-flex align-items-center justify-content-between">
              <span>
                Descrição <span className="text-danger">*</span>
              </span>
              <MessageTemplateSelector
                type="TICKET_DESCRIPTION"
                ticketId={ticketId}
                editorRef={editorRef}
                onTemplateApplied={content => {
                  setDescription(content);
                }}
              />
            </Form.Label>
            <div className="position-relative">
              <Editor
                ref={editorRef}
                value={value => setDescription(value)}
                data={data}
              />
              <MessageTemplateAutocomplete
                editorRef={editorRef}
                type="TICKET_DESCRIPTION"
                ticketId={ticketId}
                onTemplateApplied={content => {
                  setDescription(content);
                }}
              />
            </div>
            <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Insira uma desrição.
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="falcon-default"
          onClick={handleClose}
          disabled={isLoading}
        >
          Fechar
        </Button>
        <Button variant="primary" onClick={onSubmit} disabled={isLoading}>
          <FontAwesomeIcon icon={faSave} className="me-2" />
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TicketDescriptionEditModal;
